import type { Synth } from './synth';
import { JsSynthesizerSynth } from './synthJsSynthesizer';
import { MainThreadSynth } from './synthMainThread';

export type SynthBackendPreference = 'auto' | 'worklet' | 'main-thread';

export function preferenceFromUrl(): SynthBackendPreference {
  try {
    const p = new URLSearchParams(window.location.search).get('synth');
    if (p === 'main' || p === 'main-thread') return 'main-thread';
    if (p === 'worklet') return 'worklet';
  } catch {
    /* ignore */
  }
  return 'auto';
}

export function pickSynth(pref: SynthBackendPreference, ctx: AudioContext): Synth {
  if (pref === 'main-thread') return new MainThreadSynth();
  if (pref === 'worklet') return new JsSynthesizerSynth();
  // auto: AudioWorklet is gated by Secure Context — over plain HTTP from a LAN IP,
  // `ctx.audioWorklet` is undefined even though the prototype has it. Check the instance.
  if (!ctx.audioWorklet || typeof ctx.audioWorklet.addModule !== 'function') {
    return new MainThreadSynth();
  }
  return new JsSynthesizerSynth();
}

export function withTimeout<T>(p: Promise<T>, ms: number, label: string): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const t = setTimeout(() => reject(new Error(`${label} timed out after ${ms} ms`)), ms);
    p.then(
      (v) => { clearTimeout(t); resolve(v); },
      (err) => { clearTimeout(t); reject(err); },
    );
  });
}
